<template>
  <v-layout column>
    <v-flex mb-2>
      <v-layout>
        <v-spacer grow />
        <v-flex shrink>
          <StatusSelect v-model="optionForShowCreatives" />
        </v-flex>
      </v-layout>
    </v-flex>
    <CreativeScheduleTable
      v-if="useCreativeSchedule"
      :campaignBudgets="form.getNoRejectedCampaignBudgets()"
      :active-only="activeOnly"
    />
    <CreativeTable
      v-else
      :creatives="form.campaign.creatives"
      :active-only="activeOnly"
    />
  </v-layout>
</template>

<script>
import StatusSelect, {
  StatusOptions,
} from './CampaignModalPageCreativeStatusSelect'
import CreativeTable from './CampaignModalPageConfirmCreativeTable'
import CreativeScheduleTable from './CampaignModalPageConfirmCreativeScheduleTable'
export default {
  name: 'CampaignModalPageConfirmCreativeModeCampaign',
  components: { StatusSelect, CreativeTable, CreativeScheduleTable },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      optionForShowCreatives: StatusOptions.ACTIVE_ONLY,
    }
  },
  computed: {
    activeOnly() {
      return this.optionForShowCreatives === StatusOptions.ACTIVE_ONLY
    },
    useCreativeSchedule() {
      return this.form.campaign.useCreativeSchedule
    },
  },
}
</script>

<style></style>
